import React, { PureComponent } from 'react';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { showError } from '../../redux/actions/app';
import ScanButton from '../../services/ScanButton';
import { formatExpDate, isExpired } from '../../services/ScanButton/helper';
import { parseBarCode } from '../../services/ScanButton/parser';
import './UnitTest.css';

const qrCodes = [
  '0104719894432007112305121726051110A230501', // type 3
  '01069242749551151725080711220808102208047',
  '01047153091210781730013*110F20026*E210010',
  '010471530912107817280531*10F806*Y4210014',
  '01008500114270881727080110S0801A2100022',
  '0100810142320129112404231734042210F240496',
  '116200*F90667', // old QR code
];

class UnitTest extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { sCode: '', qrCode: '', log: '', scanCount: 0 };
  }

  onScan = (
    {
      sCode,
      iQty,
      type,
      sku = '',
      gtin,
      expDate,
      lotNumber,
      serialNumber,
      manufacturedDate,
      ok = false,
    },
    source = ''
  ) => {
    this.clearLog();
    const bulk = type === 'bulk';

    let text = '===== Code =====\n' + sCode + '\n===== Decoded Data =====\n';
    if (source.length > 1) {
      text += 'Source: ' + source + '\n';
    }
    text += 'Type: ' + type + '\n';
    if (ok) {
      const expired = isExpired(expDate);
      const formattedExpDate = formatExpDate(expDate);

      if (bulk) {
        text += 'SKU: ' + sku + '\n';
      } else {
        text += 'GTIN: ' + gtin + '\n';
      }

      text += 'Lot #: ' + lotNumber + '\n';
      text += `Exp Date: ${expDate} (${formattedExpDate}) \n`;
      text += `Expired: ${expired ? 'Yes' : 'No'}\n`;
      if (!!serialNumber) {
        text += 'SerialNumber #: ' + serialNumber + '\n';
      }

      text += 'Qty: ' + iQty + '\n';

      if (expired) {
        this.props.showError(`Expired!\nExp Date: ${formattedExpDate}`);
      }
    }
    text += `Result: ${ok ? 'OK' : 'Error'}`;

    this.writeLog(text);
  };

  writeLog = (str) => {
    this.setState((prevState) => {
      const log = str + '\n' + prevState.log;
      return { ...prevState, log };
    });
  };

  clearLog = () => {
    this.setState({ log: '', scanCount: 0 });
  };

  simulate = (str) => {
    if (str !== '' && str.length > 0) {
      const data = parseBarCode(str);
      this.onScan(data);
    } else {
      this.writeLog('QR Code is empty');
    }
  };

  handleChangeQrCode = (event) => {
    const qrCode = event.target.value;
    this.setState({ qrCode });
  };

  handleChangeText = (event) => {
    const sCode = event.target.value;
    this.setState({ sCode });
  };

  handleChange = (event) => {
    const { value } = event.target;
    this.setState({ log: value });
  };

  handleScanResult = (result) => {
    this.onScan(result, 'Scanner');
    this.setState((prev) => ({
      ...prev,
      scanCount: prev.scanCount + 1,
    }));
  };

  render() {
    const { log } = this.state;

    return (
      <Container>
        <div className='testHeader'>
          <h5>Unit Test</h5>
          <span className='app-version'>
            (v{process.env.REACT_APP_VERSION})
          </span>
          <Link to='/'>
            <span style={{ fontSize: '1.3rem' }} role='img' aria-label='Close'>
              ✖
            </span>
          </Link>
        </div>
        <div>
          <b>Please scan a barcode to debug...</b>
        </div>
        <div className='testBtnContainer'>
          <select value={this.state.qrCode} onChange={this.handleChangeQrCode}>
            <option value=''>-------- Select QR Code --------</option>
            {qrCodes.map((qrCode, index) => (
              <option key={index} value={qrCode}>
                {qrCode}
              </option>
            ))}
          </select>
          <button
            type='button'
            onClick={() => this.simulate(this.state.qrCode)}
          >
            Decode
          </button>
        </div>
        <div className='testBtnContainer'>
          <input
            value={this.state.sCode}
            onChange={this.handleChangeText}
            placeholder='Enter QR code.'
          />
          <button type='button' onClick={() => this.simulate(this.state.sCode)}>
            Decode
          </button>
        </div>
        <div className='scan-info-container'>
          <ScanButton onScan={this.handleScanResult} debug />
          <span className='scan-counter'>{this.state.scanCount}</span>
        </div>
        <textarea
          style={{
            width: '100%',
            height: 190,
            backgroundColor: 'lightblue ',
          }}
          value={log}
          onChange={this.handleChange}
          readOnly
        />
        <button onClick={this.clearLog} style={{ width: '100%' }}>
          Clear
        </button>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  showError,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnitTest);
